import { createAction } from '@reduxjs/toolkit';

export const setChiefComplaint = createAction('[Chief Complaint] setChiefComplaint');
export const clearChiefComplaint = createAction('[Chief Complaint] clearChiefComplaint');
export const setChiefComplaintList = createAction('[Chief Complaint] setChiefComplaintList');
export const getChiefComplaintList = createAction('[Chief Complaint] getChiefComplaintList');
export const chiefComplaintDescriptionChange = createAction('[Chief Complaint] chiefComplaintDescriptionChange');
export const saveChiefComplaint = createAction('[Chief Complaint] saveChiefComplaint');
export const setChiefComplaintDirty = createAction('[Chief Complaint] setChiefComplaintDirty');
